import { UserRoleSettings, AdminUserPermissions } from '../utils/user-role';
import { mapGetters } from "vuex";
export default {
  data: function () {
    return {
      AdminUserPermissions: AdminUserPermissions,
    }
  },
  computed: {
    ...mapGetters(['imageBaseUrl']),
  },
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    hasRole(role) {
      return new UserRoleSettings().hasRole(role)
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    htmlToExcel(id, name, isClass) {
      var uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
        base64 = function(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
            return c[p];
          });
        };
      let table = "";
      if (isClass) {
        table = document.getElementsByClassName(id)[0];
      } else {
        table = document.getElementById(id);
      }
      const tds = table.querySelectorAll('th')
      const thAction = tds[tds.length - 1].innerHTML
      tds[tds.length - 1].innerHTML = ''
      if (table.querySelector('.footer-data-commission')) table.querySelector('.footer-data-commission').style.display = 'inline'
      if (table.querySelector('.v-data-footer')) table.querySelector('.v-data-footer').style.visibility = 'hidden'
      if (table.querySelectorAll('.img')) table.querySelectorAll('.img').forEach(el => {
        el.style.display = 'none'
      })
      if (table.querySelectorAll('.v-icon')) table.querySelectorAll('.v-icon').forEach(el => {
        el.style.display = 'none'
      })
      var ctx = {
        worksheet: name || "Worksheet",
        table: table.innerHTML
      };
      var a = document.createElement('a');
      a.href = uri + base64(format(template, ctx))
      a.download = name || 'download' +'.xls';
      //triggering the function
      a.click();
      // window.location.href = uri + base64(format(template, ctx));
      tds[tds.length - 1].innerHTML = thAction
      if (table.querySelectorAll('.v-icon')) table.querySelectorAll('.v-icon').forEach(el => {
        el.style.display = 'block'
      })
      if (table.querySelector('.v-data-footer')) table.querySelector('.v-data-footer').style.visibility = 'visible'
      if (table.querySelector('.footer-data-commission')) table.querySelector('.footer-data-commission').style.display = 'none'
      this.$root.$emit(id)
      this.footer=false
    },
  }
}
